/**
 * @module Productfavourite 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import AuthApi from '@/Components/Controllers/AuthApis';
import * as _ from 'lodash';


export default {

    /**
     * Fetch fav products of user   favProductListByProductIds: _.debounce(
     */
    async favProductListByProductIds (product_ids)  {
        // const url = `${Env.productUrl}/api/v1/locationProducts/getProducts?include_location_product_brand=1&include_location_product_terpenes=1&include_location_product_aromas=1&include_location_product_images=1&include_location_product_cannabis_attributes=1&include_location_product_thc_cbd_levels=1&include_location_product_colours=1&include_location_product_flavours=1&include_location_product_moods=1&include_location_product_allergens=1&include_location_product_variants=1&include_location_product_reviews=1&include_notification_subscribers=1`;
        const url = `${Env.productUrl}/api/v1/locationProducts/getProducts?include_location_product_brand=1&include_location_product_terpenes=1&include_location_product_images=1&include_location_product_cannabis_attributes=1&include_location_product_thc_cbd_levels=1&include_location_product_variants=1&include_location_product_category=1`;
        return AuthApi.postApi(url, {
          "app-id": Env.productAppId,
          "app-secret": Env.productAppSecret
        }, {
          product_ids
        })
        .then(res => {
          store.dispatch('favouriteproducts/setList', res.data.payload)
          return res;
        })
        .catch(err => {
          store.dispatch('favouriteproducts/setList', []);
          return err;
        });
    }, // , 1000)

    favProductListByProductIdsOLD(product_ids) {
      const url = `${Env.productUrl}/api/v1/locationProducts/getProducts?include_location_product_brand=1&include_location_product_terpenes=1&include_location_product_aromas=1&include_location_product_images=1&include_location_product_cannabis_attributes=1&include_location_product_thc_cbd_levels=1&include_location_product_colours=1&include_location_product_flavours=1&include_location_product_moods=1&include_location_product_allergens=1&include_location_product_variants=1&include_location_product_reviews=1&include_notification_subscribers=1`;
      return AuthApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      }, {
        product_ids
      })
      .then(res => {
        store.dispatch('favouriteproducts/setList', res.data.payload)
        return res;
      })
      .catch(err => {
        store.dispatch('favouriteproducts/setList', []);
        return err;
      });
    },

    // /**
    //  * Fav product by product id
    //  */
    // favProduct({
    //     location_id,
    //     product_id,
    //     location_product_id,
    //     product_name,
    //     product_type,
    // }) {
    //     store.dispatch('spinner/setSpinner', true);
    //     const url = `${Env.productUrl}/api/v1/userFavorite/create`;
    //     return AuthApi.postApi(url, {
    //       "app-id": Env.productAppId,
    //       "app-secret": Env.productAppSecret
    //     }, {
    //             user_id: store.getters.getLoggedInUserId,
    //             location_id,
    //             product_id,
    //             location_product_id,
    //             product_name,
    //             product_type,
    //         })
    //         .then(res => {
    //             store.dispatch('spinner/setSpinner', false);
    //             this.fetch(location_id);
    //             return res;
    //         })
    //         .catch(err => {
    //             store.dispatch('spinner/setSpinner', false);
    //             return err;
    //         });
    // },

    // /**
    //  * remove fav product
    //  */
    // unFavProduct(location_id, favId) {
    //     store.dispatch('spinner/setSpinner', true);
    //     const url = `${Env.productUrl}/api/v1/userFavorite/${favId}/delete`;
    //     return AuthApi.deleteApi(url,{
    //       "app-id": Env.productAppId,
    //       "app-secret": Env.productAppSecret
    //     }, {})
    //         .then(res => {
    //             store.dispatch('spinner/setSpinner', false);
    //             this.fetch(location_id);
    //             return res;
    //         })
    //         .catch(err => {
    //             store.dispatch('spinner/setSpinner', false);
    //             return err;
    //         });
    // },



}